import type { Elemental, ElementalFormData } from '../types/elemental'
import { useSidebarStore } from './sidebar'
type ElementalFormMode = 'edit' | 'create'

export interface ElementalFormState {
  isOpen: boolean
  mode: ElementalFormMode | null
  data: ElementalFormData | null
  values: ElementalFormData | null
  elementalTypeId: ElementalTypeEnum | null
  isSaving: boolean
}

const initialState: ElementalFormState = {
  isOpen: false,
  mode: null,
  data: null,
  values: null,
  elementalTypeId: null,
  isSaving: false,
}

const getFromLocalStorage = <T>(initialState: T): T => {
  if (process.server)
    return initialState

  try {
    const data = window.localStorage?.getItem('sidebar-form')
    if (!data)
      return initialState

    const parsed = JSON.parse(data)
    return {
      ...initialState,
      ...parsed,
    }
  }
  catch (error) {
    return initialState
  }
}

export const useElementalFormStore = defineStore('elemental-form', {
  state: (): ElementalFormState => getFromLocalStorage<ElementalFormState>(initialState),
  actions: {
    toggle() {
      this.isOpen = !this.isOpen
    },
    open(mode: ElementalFormMode, data: ElementalFormData | Elemental, elementalTypeId: ElementalTypeEnum, clearHistory = false) {
      const sidebarStore = useSidebarStore()
      const elementalFormData = toRaw(data) as ElementalFormData
      const itemInHistory = elementalFormData
      sidebarStore.goToEdit(itemInHistory, clearHistory)
      this.mode = mode
      this.data = elementalFormData
      this.elementalTypeId = elementalTypeId
      this.isOpen = true
    },
    close() {
      const sidebarStore = useSidebarStore()
      sidebarStore.goToView()
      const { resetQuery } = useRouterQueryParams()
      resetQuery('sbarr_f')
      this.$reset()
    },
    updateFormValues(values: ElementalFormData) {
      this.values = values
    },

  },
  getters: {
    watchField: (state) => {
      return (field: keyof ElementalFormData) => {
        return state.data?.[field]
      }
    },
    checkEditId(state) {
      return (id: any) => {
        return state.data?.id === id
      }
    },
  },
})

if (process.client) {
  const current = useElementalFormStore().$state.data?.id
  if (!current) {
    const storateState = getFromLocalStorage<ElementalFormState>(initialState)
    if (storateState.data?.id)
      useElementalFormStore().$patch(getFromLocalStorage<ElementalFormState>(initialState))
  }
  useElementalFormStore().$subscribe((_, state) => {
    if (
      !state.isOpen

    ) {
      const { resetQuery } = useRouterQueryParams()
      resetQuery('sbarr_f')
    }
    window.localStorage.setItem('sidebar-form', JSON.stringify(state))
  })
}
